var intervalCount = 0;
hideInterval = setInterval(function() {
  // hideProductInfoIfRebuyEnabled();
  if (intervalCount > 4) {
    clearInterval(hideInterval);
  }
}, 2000);
// function hideProductInfoIfRebuyEnabled(){
//   intervalCount = intervalCount + 1;
//   var $reBuy = $("#rebuy-widget-82762 .rebuy-bundle__items")[0].children
//   if ($reBuy.length > 0){
//     $(".product-form__buttons").hide();
//     $(".hide-for-bundle").attr('style', 'display: none !important');
//     $(".hide-for-bundle").addClass('hide-product-info-rebuy');
//   }  
// }
